import { useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import AuthAction from "../store/auth/action";

const ForgotPassword = () => {
    const dispatch = useAppDispatch();
    const { isLoading, error, resetPasswordCodeSent } = useAppSelector((state) => state.auth);
    const [email, setEmail] = useState("");

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (email) AuthAction.resetPasswordGetCode(email.trim(), dispatch);
    };

    if (resetPasswordCodeSent) {
        AuthAction.clearState(dispatch);
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#f8f2ed] font-manrope">
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm text-center">
                    <h2 className="text-xl font-semibold text-[#704e37] mb-2">Email i dërguar</h2>
                    <p className="text-gray-600 mb-4">Shikoni email-in tuaj për të rivendosur fjalëkalimin.</p>
                    <Link to="/login" className="text-[#704e37] font-medium">Shko te Kyçuni</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#f8f2ed] font-manrope">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
                <h2 className="text-2xl font-semibold mb-6 text-center text-[#704e37]">Rivendosni fjalëkalimin</h2>
                <form onSubmit={onSubmit}>
                    <input
                        className="w-full border rounded py-2 px-3 mb-4 focus:ring-1 focus:ring-[#ebcaaa]"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    {error && <p className="text-xs text-red-500 mb-2">{error}</p>}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-[#704e37] text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                    >
                        {isLoading ? "Prisni..." : "Dërgo linkun"}
                    </button>
                </form>
                <p className="text-center text-sm text-gray-600 mt-4">
                    <Link to="/login" className="text-[#704e37] font-medium">Kthehu te Kyçuni</Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;
